module.exports = __webpack_public_path__ + "img/om.64766906.svg";